import axios from 'axios';

let prefix = "/user-asset-balance"

const UserAssetBalanceApi = {

	getUserAssetBalanceList(payload) {
		return axios.get(prefix + "/list-admin", { params: payload })
	},
	getUserAssetBalanceTypeList(payload) {
		return axios.get(prefix + "/type", { params: payload })
	},
	topupUserAsset(payload) {
		return axios.post(prefix + "/topup", payload)
	},
	deductUserAsset(payload) {
		return axios.post(prefix + "/deduct", payload)
	},
}

export default UserAssetBalanceApi;